<template>
  <section id="benefits">
    <h2 class="benefits_heading">
      イベント特典
    </h2>
    <Checklist
      :items="[
        'イベント特典はWEBイベント詳細ページからご確認ください。',
        '申込みの際は注意事項をよくご確認の上、申込みください。',
        'イベント特典はWEBイベントごとに異なりますのでご注意ください。'
      ]"
    />
    <div class="responsive-card">
      <SeminarCassette
        v-for="(item, idx) in benefits"
        :key="`benefits-${idx}`"
        :heading="item.title"
      >
        <img v-if="item.image" :src="item.image.url" alt="" />
        <p v-html="item.description"></p>
      </SeminarCassette>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent, PropType } from '@vue/runtime-core'
import Checklist from '@/components/block/Checklist.vue'
import SeminarCassette from '@/components/block/SeminarCassette.vue'
import { WpImage } from '@/types/WpRestApi'

interface Benefit {
  title: string
  description: string
  image: WpImage | false
  label_icon: string
}

export default defineComponent({
  name: 'EventDetailBenefits',

  components: {
    Checklist,
    SeminarCassette
  },

  props: {
    benefits: {
      type: Array as PropType<Benefit[]>,
      default: () => []
    }
  }
})
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.responsive-card {
  display: grid;
  grid-template-columns: 1fr;
  @include mixins.media() {
    grid-template-columns: 1fr 1fr;
    gap: 50px;
  }
  gap: 15px;
  img {
    padding: 10px 0 20px;
  }
}

.seminarCassette {
  & + & {
    margin: 0;
  }
}

.benefits_heading {
  margin-top: 42px;
  margin-bottom: 13px;
  font-size: 2.2rem;
  line-height: 1.5;
  font-weight: 500;
}

::v-deep(.checklist) {
  margin-bottom: 24px;
}
</style>
